export const NUMBER_CHECKING_TYPE = {
  MIN: 'minNumberValue',
  MAX: 'maxNumberValue',
};
